import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { QuotationFollowUpModel } from './models/quotation_follow_up.model'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class FollowUpService {
  constructor(private http: HttpClient) {}

  addFollowUp(followup: QuotationFollowUpModel) {
    return this.http
      .post(API_URL + '/QuotationFollowUp/AddQuotationFollowUp', followup, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updateFollowUp(followup: QuotationFollowUpModel) {
    return this.http
      .put(API_URL + '/QuotationFollowUp/UpdateQuotationFollowUp', followup, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

deleteQuotationFollowUp(quotationfollowup: QuotationFollowUpModel) {
    
    return this.http
      .delete(API_URL + '/QuotationFollowUp/DeleteQuotationFollowUp', {
        headers: {},
        body: quotationfollowup,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getQuotationFollowUps(
    quotationId: number,
  ): Observable<QuotationFollowUpModel[]> {
    return this.http
      .get(API_URL + '/QuotationFollowUp/GetQuotationFollowUps', {
        params: { quotationId },
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllFollowUps(): Observable<QuotationFollowUpModel[]> {
    return this.http
      .get(API_URL + '/QuotationFollowUp/GetAllFollowUps', {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          

          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getFollowUpsForDate(
    date: string,
    userId: number,
  ): Observable<QuotationFollowUpModel[]> {
    return this.http
      .get(API_URL + '/QuotationFollowUp/GetFollowUpsForDate', {
        params: { userId, date },
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
